import React, { useEffect, useMemo, useState, useRef } from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  IconButton,
  Tooltip,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  CircularProgress,
  Snackbar,
  Alert,
  Chip,
  Button,
  FormControl,     
  InputLabel,        
  Select,             
  MenuItem, 
  Checkbox ,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import EventIcon from "@mui/icons-material/Event";
import RefreshIcon from "@mui/icons-material/Refresh";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";

import PaidIcon from "@mui/icons-material/Paid";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";

import WarningAmberIcon from "@mui/icons-material/WarningAmber";

import axios from "axios";

import { AccountingUid, allowedUsers } from "../components/constants";

import dayjs from "dayjs";
import DateFilterBar from "../components/DateFilterBar";

import UndoIcon from "@mui/icons-material/Undo";
// to navigate to the Visit report page 
import { useNavigate } from "react-router-dom";
//===== to filter and highlight the visit request !!
import { useSearchParams } from "react-router-dom";

import AssessmentIcon from "@mui/icons-material/Assessment";

import DoneAllIcon from "@mui/icons-material/DoneAll";
import SyncIcon from "@mui/icons-material/Sync";

import EmployeeMultiSelect from "../components/attendance/EmployeeMultiSelect";

import { getDeviceStationId ,isRealPhone} from "../utils/global_functions";
// mobile responsive 
import { useTheme, useMediaQuery } from "@mui/material";

import { SupervisorUid } from "../components/constants";



// same URL helper used across every other page (Visit/Leave) — keeps
// the "http vs https" / trailing-slash handling consistent everywhere
const normalizeBaseUrl = (raw) => {
  if (!raw) return "";
  const trimmed = raw.trim().replace(/\/$/, "");
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
};

// same status numbers used in VisitHistoryPage.js — 5 is the new
// "Partial" value, everything else is unchanged so nothing else breaks
const STATUS_CONFIG = {
  0: { label: "Unsubmitted", color: "default" },
  1: { label: "Pending", color: "warning" },
  2: { label: "Approved", color: "success" },
  3: { label: "Rejected", color: "error" },
  4: { label: "Paid", color: "success" },
  5: { label: "Partial", color: "info" },
};

export default function VisitApprovalPage() {
  
  // responsive
  const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
const isCompact = useMediaQuery(theme.breakpoints.down("md"));

  const [rows, setRows] = useState([]);
// filter and search for specific visit request from whats link 
  const [searchParams, setSearchParams] = useSearchParams();
  const linkEmp = searchParams.get("emp") || "";
  const linkFrom = searchParams.get("from") || "";
  const linkTo = searchParams.get("to") || linkFrom;
  const hasLink = Boolean(linkEmp && dayjs(linkFrom).isValid());

  // Filters — restored from localStorage on load so they survive a
  // refresh or navigating to another page and back
  //* dates = the whole month(s) of the request (so the supervisor sees context), status = All.
  const [fromDate, setFromDate] = useState(() => {
    if (hasLink) return dayjs(linkFrom).startOf("month");
    const saved = localStorage.getItem("visitApproval_fromDate");
    return saved ? dayjs(saved) : dayjs().startOf("month");
  });
  const [toDate, setToDate] = useState(() => {
    if (hasLink) return dayjs(linkTo).endOf("month");
    const saved = localStorage.getItem("visitApproval_toDate");
    return saved ? dayjs(saved) : dayjs().endOf("month");
  });
  const [fullMonth, setFullMonth] = useState(() => {
    if (hasLink) return dayjs(linkFrom).isSame(dayjs(linkTo), "month");
    const saved = localStorage.getItem("visitApproval_fullMonth");
    return saved !== null ? JSON.parse(saved) : true;
  });
  const [statusFilter, setStatusFilter] = useState(() => {
    if (hasLink) return "all";
    return localStorage.getItem("visitApproval_statusFilter") || "all";
  }); // all | pending | partial | approved
  const [loadedOnce, setLoadedOnce] = useState(false);
  const [totalsLoadedOnce, setTotalsLoadedOnce] = useState(false);


  const [employeeOptions, setEmployeeOptions] = useState([]);
  // selectedEmp itself can't be restored right away — employeeOptions
  // hasn't loaded from the backend yet at mount time — it's matched
  // back in once the list arrives, via the effect further down
const [selectedEmps, setSelectedEmps] = useState([]);
   // sync-in-progress flag for the visit-only "Save All" button
  const [syncingVisits, setSyncingVisits] = useState(false);

  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({ open: false, msg: "", sev: "success" });

  // submit total trasportation summary 
  const [totalRows, setTotalRows] = useState([]);
  //*tracks which specific total row currently has a request in flight separated from actingId'visitclient
  const [actingTotalId, setActingTotalId] = useState(null);

  // tracks which single row currently has a request in flight, so we can
  // disable just that row's buttons instead of freezing the whole table
  const [actingId, setActingId] = useState(null);

    // Edit state for amount/km/parking — same idea as VisitHistoryPage's inline edit
  const [editingRow, setEditingRow] = useState(null);
  const [editValues, setEditValues] = useState({ amount: "", km: "", parking: "" });
  const [savingEdit, setSavingEdit] = useState(false);

    // Same idea, for Total Transportation rows
  const [editingTotalRow, setEditingTotalRow] = useState(null);
  const [editTotalValues, setEditTotalValues] = useState({ amount: "", km: "", parking: "" });
  const [savingTotalEdit, setSavingTotalEdit] = useState(false);

  // Shared dialog for the conflict-warning red dot — same message on
  // every row that has one, so one dialog instance covers both tables
  const [conflictDialogOpen, setConflictDialogOpen] = useState(false);

  // which visit rows are checked
const [selectedIds, setSelectedIds] = useState([]);
const [bulkApproving, setBulkApproving] = useState(false);

// which total rows are checked
const [selectedTotalIds, setSelectedTotalIds] = useState([]);


  const navigate= useNavigate();

  const baseUrl = useMemo(
    () => normalizeBaseUrl(localStorage.getItem("saved_sett_api_url") || ""),
    [],
  );

  // // the logged-in supervisor's EmpId — same source as FingerprintScanner/VisitHistoryPage use
  // const supervisorId = localStorage.getItem("shared_empid") || "";
    // the logged-in supervisor's EmpId — same fallback pattern as
  // ApproveLeavePage's spr_code, so a missing shared_empid doesn't
  // silently block the page the way it did before
  const supervisorId =
    localStorage.getItem("shared_empid") ||
    localStorage.getItem("saved_username") ||
    "";

  //To track if it is hr (payment )
  const uid = localStorage.getItem("saved_username") || "";
  const isAcc = AccountingUid.includes(uid);        // approve/pay rights
  const isHr  = allowedUsers.includes(uid);         // anyone HR-listed — sees all
  const isHrReadOnly = isHr && !isAcc;              // HR but NOT accounting → view only
  const canViewAll = isAcc || isHr;

  // pulls this supervisor's pending + partial visits from the backend —
  // canAct comes back per-row already computed by can_visit_supervisor_act()
  const fetchRows = async () => {
    if (!baseUrl || !supervisorId) return;
    setLoading(true);
    try {
      const res = await axios.get(`${baseUrl}/api/visit/pending`, {
        params: { supervisorId, isHr: canViewAll },
      });
      setRows(Array.isArray(res.data) ? res.data : []);
    } catch (e) {
      setSnack({
        open: true,
        msg: e.response?.data?.error || "Failed to load visit approvals",
        sev: "error",
      });
    } finally {
      setLoading(false);
      setLoadedOnce(true);
    }
  };

//Step 2 — fetch function for totals, mirroring fetchRows
  const fetchTotalRows = async () => {
  if (!baseUrl || !supervisorId) return;
  try {
        const res = await axios.get(`${baseUrl}/api/visit/total/pending`, {
      params: { supervisorId, isHr: canViewAll },
    });
    setTotalRows(Array.isArray(res.data) ? res.data : []);
  } catch (e) {
    setSnack({
      open: true,
      msg: e.response?.data?.error || "Failed to load total transportation approvals",
      sev: "error",
    });
  } finally {
    setTotalsLoadedOnce(true);
  }
};

// load the employee list 
// load the employee list 
useEffect(() => {
  if (!baseUrl) return;
  axios
    .get(`${baseUrl}/api/employees`, { params: { excludeUids: SupervisorUid.join(",") } })
    .then((res) => setEmployeeOptions(Array.isArray(res.data?.data) ? res.data.data : []))
    .catch(() => setEmployeeOptions([]));
}, [baseUrl]);

// EmployeeMultiSelect (same component AllAttendanceNewPage's HR filters
// use) expects {key, label} options — map the raw {empId, fullName}
// shape once here, without touching the shared component or backend.
const employeeMultiOptions = useMemo(
  () => employeeOptions.map((e) => ({ key: e.empId, label: e.fullName })),
  [employeeOptions],
);

// once the employee list has loaded, re-select whichever employees were
// saved from a previous visit to this page (if any)
// Tracks whether the restore-from-localStorage attempt has actually
// run yet. Without this, the "save" effect below fires on the very
// first render (while selectedEmps is still its initial []), wiping
// the saved value in localStorage before the employee list has even
// loaded — so the restore effect finds nothing left to restore.
const hasRestoredEmpsRef = useRef(false);

// once the employee list has loaded, re-select whichever employees were
// saved from a previous visit to this page (if any)
useEffect(() => {
  if (!employeeMultiOptions.length) return;
  if (hasRestoredEmpsRef.current) return; // only ever restore once
  hasRestoredEmpsRef.current = true;
  if (hasLink) {
    const match = employeeMultiOptions.filter((e) => String(e.key) === String(linkEmp));
    if (match.length) setSelectedEmps(match);
    return;
  }

  const savedIds = localStorage.getItem("visitApproval_selectedEmpIds");
  if (savedIds) {
    try {
      const ids = JSON.parse(savedIds);
      if (Array.isArray(ids) && ids.length) {
        const matches = employeeMultiOptions.filter((e) => ids.includes(String(e.key)));
        if (matches.length) setSelectedEmps(matches);
      }
    } catch {
      // ignore malformed saved value
    }
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [employeeMultiOptions]);


// persist every filter change so it survives a refresh or navigating away
useEffect(() => {
  if (hasLink) return;
  if (fromDate && fromDate.isValid()) localStorage.setItem("visitApproval_fromDate", fromDate.toISOString());
}, [fromDate]);

useEffect(() => {
  if (hasLink) return;
  if (toDate && toDate.isValid()) localStorage.setItem("visitApproval_toDate", toDate.toISOString());
}, [toDate]);

useEffect(() => {
  if (hasLink) return;
  localStorage.setItem("visitApproval_fullMonth", JSON.stringify(fullMonth));
}, [fullMonth]);

useEffect(() => {
  if (hasLink) return;
  localStorage.setItem("visitApproval_statusFilter", statusFilter);
}, [statusFilter]);

useEffect(() => {
  // Don't touch localStorage until the restore attempt above has
  // actually happened — otherwise this fires on mount with the
  // initial empty [] and deletes the saved selection before it can
  // ever be restored.
  if (!hasRestoredEmpsRef.current) return;
  if (hasLink) return;

  if (selectedEmps.length) {
    localStorage.setItem(
      "visitApproval_selectedEmpIds",
      JSON.stringify(selectedEmps.map((e) => String(e.key))),
    );
  } else {
    localStorage.removeItem("visitApproval_selectedEmpIds");
  }
}, [selectedEmps]);

  // load once on mount, same as ApproveLeavePage's first useEffect
  useEffect(() => {
    fetchRows();  // normal visit 
     fetchTotalRows(); //total visit 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [baseUrl, supervisorId]);

    // Apply button's real action — pulls fresh pending data from the
  // backend using the current filters. The table itself already
  // re-filters live as you change date/employee/status; Apply is for
  // explicitly refreshing against the server on demand.
  const handleApplyFilters = () => {
    fetchRows();
    fetchTotalRows();
  };

  // "Save All" for this page — same idea as AllAttendanceNewPage's Save
  // All button, but scoped to ONLY /api/visit/sync (not schedule/pleave),
  // since this page only ever deals with visits and totals.
  const handleSyncVisits = async () => {
    if (!baseUrl) return;
    setSyncingVisits(true);
    try {
      const from = fromDate.format("YYYY-MM-DD");
      const to = toDate.format("YYYY-MM-DD");
      await axios.get(`${baseUrl}/api/visit/sync`, {
        params: { fromdate: from, todate: to },
        withCredentials: true,
      });
      setSnack({ open: true, msg: "Visits synced successfully.", sev: "success" });
      await fetchRows();
      await fetchTotalRows();
    } catch (e) {
      setSnack({
        open: true,
        msg: e.response?.data?.error || "Visit sync failed.",
        sev: "error",
      });
    } finally {
      setSyncingVisits(false);
    }
  };

  // client-side date/employee/status filter — re-filters instantly
  // without re-fetching from the server
   const filteredRows = useMemo(() => {
  return rows.filter((r) => {
    const matchesEmp = !selectedEmps.length || selectedEmps.some((e) => Number(e.key) === Number(r.empId));
    const visitDate = dayjs(r.date);
    const matchesRange = visitDate.isValid()
    ? (!fromDate || !visitDate.isBefore(fromDate, "day")) &&
      (!toDate || !visitDate.isAfter(toDate, "day"))
    : true;

    // status filter
    let matchesStatus = true;
    if (statusFilter === "pending") matchesStatus = r.status === 1;
    else if (statusFilter === "partial") matchesStatus = r.status === 5;
    else if (statusFilter === "approved") matchesStatus = r.status === 2;
    else if (statusFilter === "rejected") matchesStatus = r.status === 3;
    else if (statusFilter === "paid") matchesStatus = r.status === 4;
    else if (statusFilter === "missing") matchesStatus = !(r.amount > 0) && !(r.km > 0);
    else matchesStatus = true;   // "all" really means all — don't re-filter

    return matchesEmp && matchesRange && matchesStatus;
  });
}, [rows, selectedEmps, fromDate, toDate, statusFilter]);

// same filter logic as filteredRows, but applied to totalRows instead
const filteredTotalRows = useMemo(() => {
  return totalRows.filter((r) => {
    const matchesEmp = !selectedEmps.length || selectedEmps.some((e) => Number(e.key) === Number(r.empId));
    // totals use dateFrom instead of date — same range comparison logic
    const totalDate = dayjs(r.dateFrom);
    const matchesRange = totalDate.isValid()
      ? (!fromDate || !totalDate.isBefore(fromDate, "day")) &&
        (!toDate || !totalDate.isAfter(toDate, "day"))
      : true;

    let matchesStatus = true;
    if (statusFilter === "pending") matchesStatus = r.status === 1;
    else if (statusFilter === "partial") matchesStatus = r.status === 5;
    else if (statusFilter === "approved") matchesStatus = r.status === 2;
    else if (statusFilter === "rejected") matchesStatus = r.status === 3;
    else if (statusFilter === "paid") matchesStatus = r.status === 4;
    else matchesStatus = true;   // "all"

    return matchesEmp && matchesRange && matchesStatus;
  });
}, [totalRows, selectedEmps, fromDate, toDate, statusFilter]);
// Same conflict check as VisitHistoryPage's warning banner — non-zero
// amount/km/parking on BOTH an individual visit and a Total
// Transportation summary for the same employee on an overlapping date.
// Grouped per-employee since this page mixes everyone's rows together,
// unlike VisitHistoryPage which only ever shows one employee at a time.
const { conflictingVisitIds, conflictingTotalIds } = useMemo(() => {
  const visitIds = new Set();
  const totalIds = new Set();

  const visitsByEmp = {};
  rows.forEach((v) => {
    (visitsByEmp[v.empId] ||= []).push(v);
  });
  const totalsByEmp = {};
  totalRows.forEach((t) => {
    (totalsByEmp[t.empId] ||= []).push(t);
  });

  Object.keys(visitsByEmp).forEach((empId) => {
    const empTotals = totalsByEmp[empId];
    if (!empTotals || !empTotals.length) return;

    visitsByEmp[empId].forEach((visit) => {
      const visitHasAmount  = visit.amount  > 0;
      const visitHasKm      = visit.km      > 0;
      const visitHasParking = visit.parking > 0;
      if (!visitHasAmount && !visitHasKm && !visitHasParking) return;

      const visitDate = dayjs(visit.date);

      empTotals.forEach((total) => {
        const fromD = dayjs(total.dateFrom);
        const toD   = dayjs(total.dateTo);
        if (visitDate.isBefore(fromD, "day") || visitDate.isAfter(toD, "day")) return;

        const sameAmountConflict  = visitHasAmount  && total.amount  > 0;
        const sameKmConflict      = visitHasKm      && total.km      > 0;
        const sameParkingConflict = visitHasParking && total.parking > 0;

        if (sameAmountConflict || sameKmConflict || sameParkingConflict) {
          visitIds.add(visit.entryNo);
          totalIds.add(total.entryNo);
        }
      });
    });
  });

  return { conflictingVisitIds: visitIds, conflictingTotalIds: totalIds };
}, [rows, totalRows]);

// same as leave approve page !!!!
const isLinkedVisit = (row) =>
  hasLink &&
  String(row.empId) === String(linkEmp) &&
  String(row.date || "").slice(0, 10) >= linkFrom &&
  String(row.date || "").slice(0, 10) <= linkTo;

const isLinkedTotal = (row) =>
  hasLink &&
  String(row.empId) === String(linkEmp) &&
  String(row.dateFrom || "").slice(0, 10) <= linkTo &&
  String(row.dateTo || "").slice(0, 10) >= linkFrom;

const linkNotFound =
  hasLink && loadedOnce && totalsLoadedOnce && !loading &&
  !rows.some(isLinkedVisit) && !totalRows.some(isLinkedTotal);

const clearLink = () => {
  setSelectedEmps([]);
  setSearchParams({});
};

// small red dot rendered next to a conflicting row's name — click opens
// the shared explanation dialog
const ConflictDot = () => (
  <Tooltip title="Amount/Km/Parking conflict with a Total Transportation summary — click for details">
    <IconButton size="small" onClick={() => setConflictDialogOpen(true)} sx={{ p: 0.3 }}>
      <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: "#d32f2f" }} />
    </IconButton>
  </Tooltip>
);


// select approve all 
// 2 : which rows are even eligible to be bulk-approved" for each table
  //const canApproveVisitRow = (row) => Boolean(row.canAct) && !isHrReadOnly && row.status !== 2 && row.status !== 3 && row.status !== 4;
  const canApproveVisitRow = (row) => Boolean(row.canAct) && (!isHrReadOnly || row.asSupervisor) && row.status !== 2 && row.status !== 3 && row.status !== 4;
  const selectableVisitRows = useMemo(() => filteredRows.filter(canApproveVisitRow), [filteredRows]);

  //const canApproveTotalRow = (row) => Boolean(row.canAct) && !isHrReadOnly && row.status !== 2 && row.status !== 3 && row.status !== 4;
  const canApproveTotalRow = (row) => Boolean(row.canAct) && (!isHrReadOnly || row.asSupervisor) && row.status !== 2 && row.status !== 3 && row.status !== 4;
  const selectableTotalRowsForBulk = useMemo(() => filteredTotalRows.filter(canApproveTotalRow), [filteredTotalRows]);

// 3:  select-all / toggle-one handlers, for each table
// visits
const toggleSelectAllVisits = (checked) => {
  setSelectedIds(checked ? selectableVisitRows.map((r) => r.entryNo) : []);
};
const toggleSelectVisitRow = (entryNo) => {
  setSelectedIds((prev) => (prev.includes(entryNo) ? prev.filter((id) => id !== entryNo) : [...prev, entryNo]));
};

// totals
const toggleSelectAllTotals = (checked) => {
  setSelectedTotalIds(checked ? selectableTotalRowsForBulk.map((r) => r.entryNo) : []);
};
const toggleSelectTotalRow = (entryNo) => {
  setSelectedTotalIds((prev) => (prev.includes(entryNo) ? prev.filter((id) => id !== entryNo) : [...prev, entryNo]));
};


  // A row can be edited any time it's NOT locked in as approved/paid.
  // Once the supervisor hits Undo (back to pending), it opens up again.
  const canEditRow = (row) => row.status !== 2 && row.status !== 4;
// The user is accounting.
// The visit is Approved.
// Amount is empty or 0.
// Km is empty or 0.
  const accCanFillMissing = (row) =>
    isAcc && row.status === 2 && !(Number(row.amount) > 0) && !(Number(row.km) > 0);

  const handleEditClick = (row) => {
    setEditingRow(row.entryNo);
    setEditValues({
      amount: row.amount ?? "",
      km: row.km ?? "",
      parking: row.parking ?? "",
    });
  };

   const handleSaveEdit = async (entryNo) => {
    setSavingEdit(true);
    try {
      // update_visit() freezes the old EntryNo (RecordStatusID=3) and
      // creates a brand-new active row — the response's EntryNo is the
      // ONLY valid id to act on afterwards (approve/reject/undo/etc.)
      await axios.put(`${baseUrl}/api/visit/${entryNo}`, {
        amount: editValues.amount,
        km: editValues.km,
        parking: editValues.parking,
      });
      setEditingRow(null);
      setSnack({ open: true, msg: "Visit updated.", sev: "success" });
      // re-fetch instead of patching local state — the row's EntryNo,
      // status, and everything else may have shifted server-side
      await fetchRows();
    } catch (e) {
      setSnack({
        open: true,
        msg: e.response?.data?.error || "Update failed",
        sev: "error",
      });
    } finally {
      setSavingEdit(false);
    }
  };

    // A total can be edited any time it's NOT locked in as approved/paid —
  // same rule as canEditRow, opens back up after Undo.
  const canEditTotalRow = (row) => row.status !== 2 && row.status !== 4;

  const handleEditTotalClick = (row) => {
    setEditingTotalRow(row.entryNo);
    setEditTotalValues({
      amount: row.amount ?? "",
      km: row.km ?? "",
      parking: row.parking ?? "",
    });
  };

  const handleSaveTotalEdit = async (row) => {
    setSavingTotalEdit(true);
    try {
      // save_visit_total() is an upsert keyed on EmpId+DateFrom+DateTo —
      // since this row already exists (RecordStatusID=1), it updates it
      // IN PLACE and keeps the same EntryNo, unlike update_visit() for
      // single visits. No refetch-for-new-id concern here.
      await axios.post(`${baseUrl}/api/visit/total`, {
        empId: row.empId,
        dateFrom: row.dateFrom,
        dateTo: row.dateTo,
        amount: editTotalValues.amount,
        km: editTotalValues.km,
        parking: editTotalValues.parking,
      });
      setEditingTotalRow(null);
      setSnack({ open: true, msg: "Total transportation updated.", sev: "success" });
      await fetchTotalRows();
    } catch (e) {
      setSnack({
        open: true,
        msg: e.response?.data?.error || "Update failed",
        sev: "error",
      });
    } finally {
      setSavingTotalEdit(false);
    }
  };

 
  // shared handler for approve/reject/pay — all three hit the same
  // /api/visit/status/<entryNo> endpoint, just with a different action
  const handleAction = async (row, action) => {
  setActingId(row.entryNo);
  try {
    const stationId = getDeviceStationId();
    const res = await axios.post(`${baseUrl}/api/visit/status/${row.entryNo}`, {
      action,
      supervisorId,
      isHr: isAcc,
       stationId,
      isPhone: isRealPhone(),  // this page is desktop/browser approval, not the phone scanner
      hrUserIds: AccountingUid,
    });


    setSnack({
      open: true,
      msg:
        action === "approve" ? "Visit approved."
        : action === "reject" ? "Visit rejected."
        : action === "reopen" ? `Reopened as a new request (Entry #${res.data.newEntryNo}).`
        : "Visit marked as pending.",
      sev: "success",
    });
    await fetchRows();
  } catch (e) {
    setSnack({
      open: true,
      msg: e.response?.data?.error || `${action} failed`,
      sev: "error",
    });
  } finally {
    setActingId(null);
  }
};


  const handleTotalAction = async (row, action) => {
  setActingTotalId(row.entryNo);
  try {
    const stationId = getDeviceStationId();
    const res = await axios.post(`${baseUrl}/api/visit/total/status/${row.entryNo}`, {
      action,
      supervisorId,
      isHr: isAcc,
       stationId,
      isPhone: false,
      hrUserIds: AccountingUid, 
    });
    setSnack({
      open: true,
      msg:
        action === "approve" ? "Total transportation approved."
        : action === "reject" ? "Total transportation rejected."
        : action === "undo" ? "Approval undone."
        : action === "reopen" ? `Reopened as a new request (Entry #${res.data.newEntryNo}).`
        : "Total transportation marked as paid.",
      sev: "success",
    });
    await fetchTotalRows();
  } catch (e) {
    setSnack({
      open: true,
      msg: e.response?.data?.error || `${action} failed`,
      sev: "error",
    });
  } finally {
    setActingTotalId(null);
  }
};
//4: Approve Selected" bulk action, for each table
const handleApproveSelectedAll = async () => {
  if (!selectedIds.length && !selectedTotalIds.length) return;
  setBulkApproving(true);

  let approvedVisits = 0;
  let approvedTotals = 0;
  const failedVisits = [];
  const failedTotals = [];

  for (const entryNo of selectedIds) {
    try {
      await axios.post(`${baseUrl}/api/visit/status/${entryNo}`, { action: "approve", supervisorId, isHr: isAcc,  hrUserIds: AccountingUid });
      approvedVisits += 1;
    } catch (e) {
      failedVisits.push(entryNo);
    }
  }

  for (const entryNo of selectedTotalIds) {
    try {
      await axios.post(`${baseUrl}/api/visit/total/status/${entryNo}`, { action: "approve", supervisorId, isHr: isAcc,  hrUserIds: AccountingUid });
      approvedTotals += 1;
    } catch (e) {
      failedTotals.push(entryNo);
    }
  }

  const totalFailed = failedVisits.length + failedTotals.length;
  setSnack({
    open: true,
    msg: totalFailed
      ? `Approved ${approvedVisits} visit(s) and ${approvedTotals} total(s), ${totalFailed} failed.`
      : `Approved ${approvedVisits} visit(s) and ${approvedTotals} total(s).`,
    sev: totalFailed ? "warning" : "success",
  });

  setSelectedIds([]);
  setSelectedTotalIds([]);
  setBulkApproving(false);

  await fetchRows();
  await fetchTotalRows();
};

const goToMonthlyReport = () => {
  navigate("/home/calendar/visit-report", {
    state: {
      fromDate: fromDate ? fromDate.format("YYYY-MM-DD") : null,
      toDate: toDate ? toDate.format("YYYY-MM-DD") : null,
      // now multi-select — pass every selected employee instead of one
      empIds: selectedEmps.map((e) => e.key),
      empNames: selectedEmps.map((e) => e.label),
      status: statusFilter,
    },
  });
};

  // summary chips at the top — same idea as ApproveLeavePage's
  // Pending/Partial/Approved counters
  const counts = useMemo(() => {
    const c = { pending: 0, partial: 0, approved: 0, rejected: 0 , paid: 0};
    rows.forEach((r) => {
      if (r.status === 2) c.approved += 1;
      else if (r.status === 5) c.partial += 1;
      else if (r.status === 3) c.rejected +=1;
      else if (r.status === 4) c.paid +=1;
      else c.pending += 1;
    });
    return c;
  }, [rows]);

  // same idea as `counts`, but built from totalRows instead of rows
  const totalCounts = useMemo(() => {
    const c = { pending: 0, partial: 0, approved: 0, rejected: 0, paid: 0 };
    totalRows.forEach((r) => {
      if (r.status === 2) c.approved += 1;
      else if (r.status === 5) c.partial += 1;
      else if (r.status === 3) c.rejected += 1;
      else if (r.status === 4) c.paid += 1;
      else c.pending += 1;
    });
    return c;
  }, [totalRows]);

 // Totals for the Visits table — filteredRows is already the
// post-filter array (employee + status + date), so this reacts
// automatically to whatever's currently applied
const visitTotals = useMemo(() => ({
  amount: filteredRows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0),
  km: filteredRows.reduce((sum, r) => sum + (Number(r.km) || 0), 0),
  parking: filteredRows.reduce((sum, r) => sum + (Number(r.parking) || 0), 0),
}), [filteredRows]);

// Same idea for the Group Transportation table — swap `filteredTotalRows`
// for whatever your filtered totals array is actually called (the one
// your Total Transportation table currently .map()s over)
const transportationTotals = useMemo(() => ({
  amount: filteredTotalRows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0),
  km: filteredTotalRows.reduce((sum, r) => sum + (Number(r.km) || 0), 0),
  parking: filteredTotalRows.reduce((sum, r) => sum + (Number(r.parking) || 0), 0),
}), [filteredTotalRows]);

//(reused for both tables so you don't duplicate the chip JSX):
const renderTotalsSummary = (t) =>
  isMobile ? (
    <Stack spacing={0.75} sx={{ mb: 1.5 }}>
      <Chip icon={<PaidIcon />} size="small" label={`${t.amount.toLocaleString()} L.L amount`}
        sx={{ bgcolor: "#e8f5e9", color: "#2e7d32", fontWeight: 500, fontSize: 11, width: "100%", justifyContent: "flex-start" }} />
      <Chip icon={<PaidIcon />} size="small" label={`${t.km.toLocaleString()} Km`}
        sx={{ bgcolor: "#e3f2fd", color: "#1565c0", fontWeight: 500, fontSize: 11, width: "100%", justifyContent: "flex-start" }} />
      <Chip icon={<PaidIcon />} size="small" label={`${t.parking.toLocaleString()} L.L parking`}
        sx={{ bgcolor: "#fff8e1", color: "#e65100", fontWeight: 500, fontSize: 11, width: "100%", justifyContent: "flex-start" }} />
    </Stack>
  ) : (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap sx={{ rowGap: 1, mb: 1.5 }}>
      <Chip icon={<PaidIcon />} size="small" label={`Total Amount: ${t.amount.toLocaleString()} L.L`}
        sx={{ bgcolor: "#e8f5e9", color: "#2e7d32", fontWeight: 500, fontSize: 17 , fontWeight:"bold"}} />
      <Chip icon={<PaidIcon />} size="small" label={`Total Kilometrage: ${t.km.toLocaleString()} Km`}
        sx={{ bgcolor: "#e3f2fd", color: "#1565c0", fontWeight: 500, fontSize: 17 , fontWeight:"bold"}} />
      <Chip icon={<PaidIcon />} size="small" label={`Total Parking: ${t.parking.toLocaleString()} L.L`}
        sx={{ bgcolor: "#fff8e1", color: "#e65100", fontWeight: 500, fontSize: 17 , fontWeight:"bold"}} />
    </Stack>
  );


  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: 4,
        px: 2,
        background: {
          xs: "linear-gradient(180deg, #e0f2f1 0%, #ffffff 40%)",
          md: "linear-gradient(135deg, #e0f2f1 0%, #ffffff 55%)",
        },
      }}
    >
      <Paper
        elevation={10}
        sx={{
          width: "100%",
          maxWidth: 1200,
          p: 3,
          borderRadius: 4,
          overflow: "hidden",
          background: "linear-gradient(180deg, #ffffff 0%, #fbfffe 100%)",
          boxShadow: "0 20px 60px rgba(0,0,0,.12)",
          border: "1px solid #b2dfdb",
        }}
      >
        {/* header row: icon + title on the left, status counters on the right */}
        {/* <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 2 }}
          spacing={1.5}
        > */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          sx={{ mb: 2 }}
          spacing={1.5}
        >
          <Stack direction="row" alignItems="center" spacing={1}>
            <PaidIcon sx={{ color: "#00796b" }} />
            <Typography variant="h6" fontWeight={800} color="#004d40"  sx={{ fontSize: isCompact ? "1rem" : "1.25rem" }}>
              Approve Visit Requests
            </Typography>
          </Stack>
            {(isAcc || isHrReadOnly) && (
            <Button
              variant="outlined"
              startIcon={<AssessmentIcon />}
              onClick={goToMonthlyReport}
              sx={{ borderColor: "#00796b", color: "#00796b", fontWeight: 700, textTransform: "none" }}
            >
              Monthly Report
            </Button>
          )}

          {/* <Stack direction="row" spacing={1} alignItems="center"> */}
            <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap sx={{ rowGap: 1 }}>
            <Chip label={`Pending: ${counts.pending}`} color="warning" variant="filled" sx={{ fontWeight: 700 }} />
            <Chip label={`Partial: ${counts.partial}`} color="info" variant="outlined" sx={{ fontWeight: 700 }} />
            <Chip label={`Approved: ${counts.approved}`} color="success" variant="outlined" sx={{ fontWeight: 700 }} />
             <Chip label={`Rejected: ${counts.rejected}`} color="error" variant="outlined" sx={{ fontWeight: 700 }} />
             <Chip label={`Paid: ${counts.paid}`} color="success" variant="outlined" sx={{ fontWeight: 700 }} />
             {!isMobile &&(
                <Tooltip title={(!selectedIds.length && !selectedTotalIds.length) ? "" : "Approve all selected visits and totals"}>
                  <span>
                    <Button
                      onClick={handleApproveSelectedAll}
                      startIcon={bulkApproving ? <CircularProgress size={16} color="inherit" /> : <DoneAllIcon />}
                      variant="contained"
                      color="success"
                      size="small"
                      disabled={!baseUrl || bulkApproving || (!selectedIds.length && !selectedTotalIds.length)}
                      sx={{ fontWeight: 700, textTransform: "none", borderRadius: 2 }}
                    >
                      Approve Selected
                    </Button>
                  </span>
                </Tooltip>
                )}
          </Stack>
        </Stack>

        {/* filter bar — two clean rows: date scope + Apply on row 1, employee/status + refresh on row 2 */}
                <Box
          sx={{
            mb: 1.5,
            p: { xs: 1.25, sm: 2 },
            borderRadius: { xs: 2, sm: 3 },
            border: "1px solid #b2dfdb",
            background: "linear-gradient(180deg, #f7fffd 0%, #f1fdfb 100%)",
            boxShadow: "0 6px 20px rgba(0,0,0,.06)",
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1, sm: 1.5 },
            // shared styling for every input in this bar, applied from the outside
            // so DateFilterBar.js itself never needs to change — smaller on
            // mobile so the whole filter card takes up noticeably less room
            "& .MuiOutlinedInput-root": {
            height: { xs: 36, sm: 37, md: 40 },
            backgroundColor: "white",
            borderRadius: 2,
            fontSize: { xs: 12.5, sm: 13, md: 14 },
          },
          "& .MuiInputLabel-root": { fontSize: { xs: 11.5, sm: 12, md: 13 } },
            "& .MuiFormControlLabel-label": { fontSize: { xs: 12.5, sm: 14 } },
          }}
        >
          {/* row 1: icon + label, From/To, Full month, Apply — all one line, Apply pinned right */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={1.5}
            useFlexGap
            flexWrap="wrap"
          >
             <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: { xs: 70, sm: 90 } }}>
              <EventIcon sx={{ color: "#00796b", fontSize: { xs: 18, sm: 24 } }} />
              <Typography variant="subtitle2" sx={{ color: "#00796b", fontWeight: 700, fontSize: { xs: 13, sm: 14 } }}>
                Filters
              </Typography>
            </Stack>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "nowrap" }}>
              <DateFilterBar
                fromDate={fromDate}
                toDate={toDate}
                setFromDate={setFromDate}
                setToDate={setToDate}
                fullMonth={fullMonth}
                setFullMonth={setFullMonth}
                onApply={handleApplyFilters}
              />
            </Box>

            <Button
              variant="contained"
              onClick={handleApplyFilters}
              sx={{
                bgcolor: "#00796b",
                "&:hover": { bgcolor: "#00695c" },
                textTransform: "none",
                fontWeight: 700,
                borderRadius: 2,
                height: { xs: 34, sm: 40 },
                px: { xs: 2, sm: 3 },
                fontSize: { xs: 12.5, sm: 14 },
                whiteSpace: "nowrap",
              }}
            >
              Apply
            </Button>

            <Button
              variant="outlined"
              startIcon={syncingVisits ? <CircularProgress size={14} /> : <SyncIcon fontSize="small" />}
              onClick={handleSyncVisits}
              disabled={syncingVisits}
              sx={{
                borderColor: "#00796b",
                color: "#00796b",
                textTransform: "none",
                fontWeight: 700,
                borderRadius: 2,
                height: { xs: 34, sm: 40 },
                px: { xs: 2, sm: 3 },
                fontSize: { xs: 12.5, sm: 14 },
                whiteSpace: "nowrap",
                bgcolor: "white",
                "&:hover": { bgcolor: "#f0fffb", borderColor: "#004d40" },
              }}
            >
              Save All
            </Button>             

            <Box sx={{ flex: 1 }} />
                       {/* row 2: Employee, Status, Refresh — pinned right */}
          <Stack
            direction="row"
            alignItems="center"
            spacing={{ xs: 1, sm: 1.5 }}
            useFlexGap
            flexWrap="wrap"
          >

            {/* EmployeeMultiSelect hardcodes flex:1/minWidth:280 internally
                (it's shared with AllAttendanceNewPage, so it's left
                untouched) — this wrapper forces it to actually shrink to
                fit a phone screen instead of staying pinned at 280px+ */}
            <Box
              sx={{
                flex: { xs: "1 1 100%", sm: "1 1 260px" },
                minWidth: 0,
                "& .MuiAutocomplete-root": {
                  flex: "1 1 auto !important",
                  minWidth: "0 !important",
                  width: "100%",
                },
                "& .MuiOutlinedInput-root": {
                  minHeight: { xs: 36, sm: 40 },
                },
              }}
            >
              <EmployeeMultiSelect
                employeeOptions={employeeMultiOptions || []}
                selectedEmps={selectedEmps || []}
                onChange={setSelectedEmps}
              />
            </Box>

            <FormControl
              size="small"
              sx={{ flex: { xs: "1 1 calc(50% - 8px)", sm: "0 0 170px" }, minWidth: { xs: 120, sm: 170 } }}
            >
              <InputLabel id="visit-status-filter-label">Status</InputLabel>
              <Select
                labelId="visit-status-filter-label"
                value={statusFilter}
                label="Status"
                onChange={(e) => setStatusFilter(e.target.value)}
              >
                <MenuItem value="all">All </MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="partial">Partial</MenuItem>
                <MenuItem value="approved">Approved</MenuItem>
                <MenuItem value="paid">Paid</MenuItem>
                <MenuItem value="rejected">Rejected</MenuItem>
                <MenuItem value="missing">Missing Amount/Km</MenuItem>
              </Select>
            </FormControl>

            <Tooltip title="Refresh">
              <span>
                <IconButton
                  onClick={fetchRows}
                  disabled={loading}
                  size="small"
                  sx={{ border: "1px solid #b2dfdb", borderRadius: 2, backgroundColor: "white", height: { xs: 34, sm: 40 }, width: { xs: 34, sm: 40 }, flexShrink: 0, "&:hover": { backgroundColor: "#f0fffb" } }}
                >
                  {loading ? <CircularProgress size={18} /> : <RefreshIcon fontSize="small" />}
                </IconButton>
              </span>
            </Tooltip>
          </Stack>
          </Stack>
        </Box>


        {/* Approve Selected — full-width, sits right under the filter card
            on mobile only (matches the sketch: filters, then this button,
            then the Visits list below) */}
        {isMobile && (
          <Tooltip title={(!selectedIds.length && !selectedTotalIds.length) ? "" : "Approve all selected visits and totals"}>
            <span style={{ display: "block", marginBottom: 12 }}>
              <Button
                onClick={handleApproveSelectedAll}
                startIcon={bulkApproving ? <CircularProgress size={16} color="inherit" /> : <DoneAllIcon />}
                variant="contained"
                color="success"
                fullWidth
                size="small"
                disabled={!baseUrl || bulkApproving || (!selectedIds.length && !selectedTotalIds.length)}
                sx={{ fontWeight: 700, textTransform: "none", borderRadius: 2 }}
              >
                Approve Selected
              </Button>
            </span>
          </Tooltip>
        )}

        {hasLink && (
          <Alert
            severity={linkNotFound ? "warning" : "info"}
            sx={{ mb: 1.5, borderRadius: 2, alignItems: "center" }}
            action={
              <Button size="small" onClick={clearLink} sx={{ fontWeight: 700, textTransform: "none" }}>
                Show all
              </Button>
            }
          >
            {linkNotFound ? "This request is no longer available." : "Showing the request from your message."}
          </Alert>
        )}

        {renderTotalsSummary(visitTotals)}

        {/* //! For Mobile responsive  */}
        {isMobile ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
            <Stack direction="row" alignItems="center" justifyContent="space-between">
              <Typography variant="caption" sx={{ color: "#004d40", fontWeight: 700, textTransform: "uppercase", fontSize: 11 }}>
                Visits
              </Typography>
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <Checkbox
                  size="small"
                  checked={selectableVisitRows.length > 0 && selectedIds.length === selectableVisitRows.length}
                  indeterminate={selectedIds.length > 0 && selectedIds.length < selectableVisitRows.length}
                  onChange={(e) => toggleSelectAllVisits(e.target.checked)}
                  disabled={selectableVisitRows.length === 0}
                  sx={{ p: 0.3 }}
                />
                <Typography variant="caption" sx={{ color: "text.secondary" }}>Select all</Typography>
              </Stack>
            </Stack>

            {!filteredRows.length && (
              <Typography variant="body2" sx={{ opacity: 0.5, color: "#004d40", textAlign: "center", py: 2 }}>
                {loading ? "Loading…" : "No visits waiting on your approval"}
              </Typography>
            )}

            {filteredRows.map((row) => {
              // const canAct = Boolean(row.canAct);
              //const canAct = Boolean(row.canAct) && !isHrReadOnly;
              const canAct = Boolean(row.canAct) && (!isHrReadOnly || row.asSupervisor);
              const isBusy = actingId === row.entryNo;
              const sc = STATUS_CONFIG[row.status] || STATUS_CONFIG[1];
              const canPay = row.status === 2;
              const isApproved = row.status === 2;
              const isRejected = row.status === 3;
              const isPaid = row.status === 4;
              const iApproved = Boolean(row.iApproved);
              const isEditingThis= editingRow === row.entryNo;
              const canEdit = (!isApproved && !isPaid && !isHrReadOnly) || accCanFillMissing(row);

              return (
                <Paper
                  key={row.entryNo}
                  elevation={1}
                  sx={{
                    borderRadius: 2,
                    border: "1px solid",
                    // highlight the visit !!! 
                    borderColor: isLinkedVisit(row) ? "#f9a825" : selectedIds.includes(row.entryNo) ? "#00796b" : "#e0f2f1",
                    borderWidth: isLinkedVisit(row) ? 2 : 1,
                    backgroundColor: isLinkedVisit(row) ? "#fff8e1" : undefined,
                    p: 1.5,
                  }}
                >
                  <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 0.5 }}>
                     <Box>
                      <Stack direction="row" alignItems="center" spacing={0.3}>
                        <Typography variant="body2" fontWeight={700} sx={{ color: "#004d40" }}>
                          {row.fullName}
                        </Typography>
                        {conflictingVisitIds.has(row.entryNo) && <ConflictDot />}
                      </Stack>
                      <Typography variant="caption" sx={{ color: "text.secondary" }}>
                        {row.visitFrom} → {row.visitTo} · {row.date}
                      </Typography>
                    </Box>
                    
                    <Chip label={sc.label} color={sc.color} size="small" variant="filled" sx={{ fontWeight: 700, fontSize: 11 }} />
                  </Stack>

                  {isEditingThis ? (
                    <Stack direction="row" spacing={1} sx={{ my: 1 }}>
                      <TextField
                        size="small" label="Amount" type="number" fullWidth
                        value={editValues.amount}
                        onChange={(e) => setEditValues((prev) => ({ ...prev, amount: e.target.value }))}
                        inputProps={{ min: 0, step: 50 }}
                      />
                      <TextField
                        size="small" label="Km" type="number" fullWidth
                        value={editValues.km}
                        onChange={(e) => setEditValues((prev) => ({ ...prev, km: e.target.value }))}
                        inputProps={{ min: 0, step: 0.1 }}
                      />
                      <TextField
                        size="small" label="Parking" type="number" fullWidth
                        value={editValues.parking}
                        onChange={(e) => setEditValues((prev) => ({ ...prev, parking: e.target.value }))}
                        inputProps={{ min: 0, step: 50 }}
                      />
                    </Stack>
                  ) : (
                    <Stack direction="row" justifyContent="space-between" sx={{ my: 1 }}>
                      <Typography variant="body2">{Number(row.amount).toLocaleString()} L.L</Typography>
                      <Typography variant="body2">{row.km} Km</Typography>
                      <Typography variant="body2">{Number(row.parking).toLocaleString()} L.L park.</Typography>
                    </Stack>
                  )}

                  <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Checkbox
                      size="small"
                      checked={selectedIds.includes(row.entryNo)}
                      onChange={() => toggleSelectVisitRow(row.entryNo)}
                      disabled={!canApproveVisitRow(row)}
                    />
                    <Stack direction="row" spacing={0.5}>
                      <Tooltip title={isEditingThis ? "Save changes" : canEdit ? "Edit amount / km / parking" : "Undo approval first to edit"}>
                        <span>
                          <IconButton
                            size="small"
                            onClick={() => (isEditingThis ? handleSaveEdit(row.entryNo) : handleEditClick(row))}
                            disabled={(!isEditingThis && !canEdit) || savingEdit}
                            sx={{ backgroundColor: isEditingThis ? "#e8f5e9" : "#eceff1" }}
                          >
                            {isEditingThis ? (
                              savingEdit ? <CircularProgress size={16} /> : <SaveIcon fontSize="small" sx={{ color: "#2e7d32" }} />
                            ) : (
                              <EditIcon fontSize="small" />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>
                      {isPaid ? (
                        <IconButton color="success" size="small" sx={{ backgroundColor: "#e8f5e9" }} disabled>
                          <CheckCircleOutlineIcon fontSize="small" />
                        </IconButton>
                      ) : isApproved ? (
                        <IconButton color="warning" onClick={() => handleAction(row, "undo")} size="small" sx={{ backgroundColor: "#fff8e1" }} disabled={isBusy}>
                          <UndoIcon fontSize="small" />
                        </IconButton>
                      ) : isRejected ? (
                        <IconButton color="warning" onClick={() => handleAction(row, "reopen")} size="small" sx={{ backgroundColor: "#fff8e1" }} disabled={!canAct || isBusy}>
                          <UndoIcon fontSize="small" />
                        </IconButton>
                      ) : iApproved ? (
                        <IconButton color="warning" onClick={() => handleAction(row, "undo")} size="small" sx={{ backgroundColor: "#fff8e1" }} disabled={isBusy}>
                          <UndoIcon fontSize="small" />
                        </IconButton>
                      ) : !canAct ? (
                        <IconButton color="success" size="small" sx={{ backgroundColor: "#e8f5e9" }} disabled>
                          <CheckCircleOutlineIcon fontSize="small" />
                        </IconButton>
                      ) : (
                        <IconButton color="success" onClick={() => handleAction(row, "approve")} size="small" sx={{ backgroundColor: "#e8f5e9" }} disabled={isBusy}>
                          <CheckCircleOutlineIcon fontSize="small" />
                        </IconButton>
                      )}

                      <IconButton
                        color="error"
                        onClick={() => handleAction(row, "reject")}
                        size="small"
                        sx={{ backgroundColor: "#ffebee" }}
                        disabled={isPaid || isRejected || (!canAct && !isApproved) || isBusy}
                      >
                        <CancelOutlinedIcon fontSize="small" />
                      </IconButton>

                      {isAcc && (
                        isPaid ? (
                          <IconButton size="small" sx={{ backgroundColor: "#fff8e1" }} disabled={isBusy} onClick={() => handleAction(row, "unpay")}>
                            <UndoIcon fontSize="small" sx={{ color: "#f9a825" }} />
                          </IconButton>
                        ) : (
                          <IconButton size="small" sx={{ backgroundColor: "#fff8e1" }} disabled={!canPay || isBusy} onClick={() => handleAction(row, "pay")}>
                            <PaidIcon fontSize="small" sx={{ color: "#f9a825" }} />
                          </IconButton>
                        )
                      )}
                    </Stack>
                  </Stack>
                </Paper>
              );
            })}
          </Box>
        ) : (
        //{/* main table — one row per visit, columns match VisitHistoryPage's table for consistency */}
        <Paper elevation={3} sx={{ borderRadius: 2, overflow: "auto", maxWidth: "100%" }}>
          <TableContainer sx={{ maxHeight: "70vh" }}>
            <Table size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox" sx={{ backgroundColor: "#004d40" }}>
                    <Checkbox
                      color="primary"
                      indeterminate={selectedIds.length > 0 && selectedIds.length < selectableVisitRows.length}
                      checked={selectableVisitRows.length > 0 && selectedIds.length === selectableVisitRows.length}
                      onChange={(e) => toggleSelectAllVisits(e.target.checked)}
                      disabled={selectableVisitRows.length === 0}
                      sx={{ color: "white", "&.Mui-checked": { color: "#80cbc4" }, "&.MuiCheckbox-indeterminate": { color: "#80cbc4" } }}
                    />
                  </TableCell>
                  <TableCell sx={{ backgroundColor: "#004d40", color: "white", fontWeight: "bold",textAlign:"center" }}>Employee</TableCell>
                  <TableCell sx={{ backgroundColor: "#004d40", color: "white", fontWeight: "bold",textAlign:"center" }}>Visit From</TableCell>
                  <TableCell sx={{ backgroundColor: "#004d40", color: "white", fontWeight: "bold",textAlign:"center" }}>Visit To</TableCell>
                  <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold",textAlign:"center" }}>Date</TableCell>
                  <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold",textAlign:"center" }}>Amount (L.L)</TableCell>
                  <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold" ,textAlign:"center"}}>Km</TableCell>
                  <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold",textAlign:"center" }}>Parking (L.L)</TableCell>
                  <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold",textAlign:"center" }}>Status</TableCell>
                  <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold",textAlign:"center" }} align="center">
                    Actions
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {filteredRows.map((row) => {
                  // const canAct = Boolean(row.canAct);
                  //const canAct = Boolean(row.canAct) && !isHrReadOnly;
                  const canAct = Boolean(row.canAct) && (!isHrReadOnly || row.asSupervisor);
                  const isBusy = actingId === row.entryNo;
                  const sc = STATUS_CONFIG[row.status] || STATUS_CONFIG[1];
                  const canPay = row.status === 2;
                  const isEditingThis = editingRow === row.entryNo;

                  return (
                    <TableRow
                      key={row.entryNo}
                      hover
                      sx={{
                        "& td": { fontSize: 13, py: 0.9, px: 1.5 },
                        backgroundColor: isLinkedVisit(row) ? "#fff8e1" : undefined,
                        "& td:first-of-type": { borderLeft: isLinkedVisit(row) ? "4px solid #f9a825" : undefined },
                      }}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          color="primary"
                          checked={selectedIds.includes(row.entryNo)}
                          onChange={() => toggleSelectVisitRow(row.entryNo)}
                          disabled={!canApproveVisitRow(row)}
                        />
                      </TableCell>
                      <TableCell sx={{ fontWeight: 600, color: "#004d40", textAlign: "center" }}>
                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.3}>
                          <span>{row.fullName}</span>
                          {conflictingVisitIds.has(row.entryNo) && <ConflictDot />}
                        </Stack>
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>{row.visitFrom}</TableCell>
                      <TableCell sx={{ textAlign: "center" }}>{row.visitTo}</TableCell>
                      <TableCell sx={{ textAlign: "center" }}>{row.date}</TableCell>
                      <TableCell align="center">
                      {isEditingThis ? (
                        <TextField
                          size="small" type="number" value={editValues.amount}
                          onChange={(e) => setEditValues((prev) => ({ ...prev, amount: e.target.value }))}
                          inputProps={{ min: 0, step: 50, style: { textAlign: "center" } }}
                          sx={{ width: 100 }}
                        />
                      ) : (
                        Number(row.amount).toLocaleString()
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {isEditingThis ? (
                        <TextField
                          size="small" type="number" value={editValues.km}
                          onChange={(e) => setEditValues((prev) => ({ ...prev, km: e.target.value }))}
                          inputProps={{ min: 0, step: 0.1, style: { textAlign: "center" } }}
                          sx={{ width: 80 }}
                        />
                      ) : (
                        row.km
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {isEditingThis ? (
                        <TextField
                          size="small" type="number" value={editValues.parking}
                          onChange={(e) => setEditValues((prev) => ({ ...prev, parking: e.target.value }))}
                          inputProps={{ min: 0, step: 50, style: { textAlign: "center" } }}
                          sx={{ width: 90 }}
                        />
                      ) : (
                        Number(row.parking).toLocaleString()
                      )}
                    </TableCell>

                      <TableCell>
                        <Chip label={sc.label} color={sc.color} size="small" variant="filled" sx={{ fontWeight: 700, fontSize: 11 }} />
                      </TableCell>

                      <TableCell align="center">
                        <Stack direction="row" justifyContent="center" spacing={0.5}>
                         {(() => {
                            const isApproved = row.status === 2;
                            const isRejected = row.status === 3;
                            const isPaid = row.status === 4;
                            const iApproved = Boolean(row.iApproved);
                            const canEdit = (!isApproved && !isPaid && !isHrReadOnly) || accCanFillMissing(row);

                            return (
                              <>
                              {/* Edit / Save amount, km, parking — locked once approved or paid, opens back up after Undo */}
                                <Tooltip title={isEditingThis ? "Save changes" : canEdit ? "Edit amount / km / parking" : "Undo approval first to edit"}>
                                  <span>
                                    <IconButton
                                      size="small"
                                      onClick={() => (isEditingThis ? handleSaveEdit(row.entryNo) : handleEditClick(row))}
                                      disabled={(!isEditingThis && !canEdit) || savingEdit}
                                      sx={{ backgroundColor: isEditingThis ? "#e8f5e9" : "#eceff1" }}
                                    >
                                      {isEditingThis ? (
                                        savingEdit ? <CircularProgress size={16} /> : <SaveIcon fontSize="small" sx={{ color: "#2e7d32" }} />
                                      ) : (
                                        <EditIcon fontSize="small" />
                                      )}
                                    </IconButton>
                                  </span>
                                </Tooltip>

                                {/* Approve / Undo / Reopen / Disabled — now shown to BOTH HR and regular supervisors */}
                                {isPaid ? (
                                  <Tooltip title="Already paid — fully closed">
                                    <span>
                                      <IconButton color="success" size="small" sx={{ backgroundColor: "#e8f5e9" }} disabled>
                                        <CheckCircleOutlineIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                ) : isApproved ? (
                                  <Tooltip title="Undo approval (back to pending)">
                                    <span>
                                      <IconButton
                                        color="warning"
                                        onClick={() => handleAction(row, "undo")}
                                        size="small"
                                        sx={{ backgroundColor: "#fff8e1", "&:hover": { backgroundColor: "#ffecb3" } }}
                                        disabled={isBusy}
                                      >
                                        <UndoIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                                                  ) : isRejected ? (
                                  <Tooltip title={canAct ? "Reopen as a new request" : "Only the supervisor who rejected this can reopen it"}>
                                    <span>
                                      <IconButton
                                        color="warning"
                                        onClick={() => handleAction(row, "reopen")}
                                        size="small"
                                        sx={{ backgroundColor: "#fff8e1", "&:hover": { backgroundColor: "#ffecb3" } }}
                                        disabled={!canAct || isBusy}
                                      >
                                        <UndoIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                ) : iApproved ? (
                                  <Tooltip title="You already approved this — click to undo">
                                    <span>
                                      <IconButton
                                        color="warning"
                                        onClick={() => handleAction(row, "undo")}
                                        size="small"
                                        sx={{ backgroundColor: "#fff8e1", "&:hover": { backgroundColor: "#ffecb3" } }}
                                        disabled={isBusy}
                                      >
                                        <UndoIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                ) : !canAct ? (
                                  <Tooltip title="Not your turn yet — a prior supervisor must act first">
                                    <span>
                                      <IconButton color="success" size="small" sx={{ backgroundColor: "#e8f5e9" }} disabled>
                                        <CheckCircleOutlineIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                ) : (
                                  <Tooltip title={isAcc ? "Approve (final sign-off — only once all supervisors have approved)" : "Approve"}>
                                    <span>
                                      <IconButton
                                        color="success"
                                        onClick={() => handleAction(row, "approve")}
                                        size="small"
                                        sx={{ backgroundColor: "#e8f5e9", "&:hover": { backgroundColor: "#c8e6c9" } }}
                                        disabled={isBusy}
                                      >
                                        <CheckCircleOutlineIcon fontSize="small" />
                                      </IconButton>
                                    </span>
                                  </Tooltip>
                                )}

                                {/* Reject — now shown to BOTH HR and regular supervisors */}
                                <Tooltip title={isPaid ? "Already paid" : isRejected ? "Already rejected — use Reopen instead" : (canAct || iApproved) ? "Reject" : "Not your turn yet"}>
                                  <span>
                                    <IconButton
                                      color="error"
                                      onClick={() => handleAction(row, "reject")}
                                      size="small"
                                      sx={{ backgroundColor: "#ffebee", "&:hover": { backgroundColor: "#ffcdd2" } }}
                                      disabled={isPaid || isRejected || (!canAct && !isApproved && !iApproved) || isBusy}
                                    >
                                      <CancelOutlinedIcon fontSize="small" />
                                    </IconButton>
                                  </span>
                                </Tooltip>

                                {/* Pay — still HR only, unchanged */}
                                {isAcc && (
                                  isPaid ? (
                                    <Tooltip title="Cancel payment (back to Approved)">
                                      <span>
                                        <IconButton
                                          size="small"
                                          sx={{ backgroundColor: "#fff8e1", "&:hover": { backgroundColor: "#ffecb3" } }}
                                          disabled={isBusy}
                                          onClick={() => handleAction(row, "unpay")}
                                        >
                                          <UndoIcon fontSize="small" sx={{ color: "#f9a825" }} />
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                  ) : (
                                    <Tooltip title={canPay ? "Mark as paid" : "Only available once fully approved"}>
                                      <span>
                                        <IconButton
                                          size="small"
                                          sx={{ backgroundColor: "#fff8e1", "&:hover": { backgroundColor: "#ffecb3" } }}
                                          disabled={!canPay || isBusy}
                                          onClick={() => handleAction(row, "pay")}
                                        >
                                          <PaidIcon fontSize="small" sx={{ color: "#f9a825" }} />
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                  )
                                )}
                              </>
                            );
                          })()}
                        </Stack>
                      </TableCell>
                    </TableRow>
                  );
                })}

                {!filteredRows.length && (
                  <TableRow>
                    <TableCell colSpan={9} sx={{ textAlign: "center", py: 3, opacity: 0.5 }}>
                      <Typography variant="body2" fontWeight={600} sx={{ color: "#004d40" }}>
                        {loading ? "Loading…" : "No visits waiting on your approval"}
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        )}

        {/* Total Transportation approvals — same design language as the visits table above */}
        <Box sx={{ mt: 3 }}>
          {/* <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          sx={{ mb: 2 }}
          spacing={1.5}
        > */}
        <Stack
         direction={{ xs: "column", sm: "row" }}
         alignItems={{ xs: "stretch", sm: "center" }}
          
          justifyContent="space-between"
          sx={{ mb: 2 }}
          spacing={1.5}
        >

          <Stack direction="row" alignItems="flex-start" spacing={1}>
            <PaidIcon sx={{ color: "#00796b" }} />
            <Typography variant="h6" fontWeight={800} color="#004d40" sx={{fontSize: { xs: "1rem", sm: "1.25rem" }}}>
              Approve Group Transportation
            </Typography>
         </Stack>
           {/* <Stack direction="row" spacing={1} alignItems="center"> */}
           <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap" useFlexGap sx={{ rowGap: 1 }}>
            <Chip label={`Pending: ${totalCounts.pending}`} color="warning" variant="filled" sx={{ fontWeight: 700 }} />
            <Chip label={`Partial: ${totalCounts.partial}`} color="info" variant="outlined" sx={{ fontWeight: 700 }} />
            <Chip label={`Approved: ${totalCounts.approved}`} color="success" variant="outlined" sx={{ fontWeight: 700 }} />
             <Chip label={`Rejected: ${totalCounts.rejected}`} color="error" variant="outlined" sx={{ fontWeight: 700 }} />
             <Chip label={`Paid: ${totalCounts.paid}`} color="success" variant="outlined" sx={{ fontWeight: 700 }} />
          </Stack>
        </Stack>

           {renderTotalsSummary(transportationTotals)}

          {isMobile ? (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.25 }}>
              <Stack direction="row" alignItems="center" justifyContent="space-between">
                <Typography variant="caption" sx={{ color: "#004d40", fontWeight: 700, textTransform: "uppercase", fontSize: 11 }}>
                  Total Transportation
                </Typography>
                <Stack direction="row" alignItems="center" spacing={0.5}>
                  <Checkbox
                    size="small"
                    checked={selectableTotalRowsForBulk.length > 0 && selectedTotalIds.length === selectableTotalRowsForBulk.length}
                    indeterminate={selectedTotalIds.length > 0 && selectedTotalIds.length < selectableTotalRowsForBulk.length}
                    onChange={(e) => toggleSelectAllTotals(e.target.checked)}
                    disabled={selectableTotalRowsForBulk.length === 0}
                    sx={{ p: 0.3 }}
                  />
                  <Typography variant="caption" sx={{ color: "text.secondary" }}>Select all</Typography>
                </Stack>
              </Stack>

              {!filteredTotalRows.length && (
                <Typography variant="body2" sx={{ opacity: 0.5, color: "#004d40", textAlign: "center", py: 2 }}>
                  No total transportation summaries waiting on your approval
                </Typography>
              )}

              {filteredTotalRows.map((row) => {
                const canAct = Boolean(row.canAct);
                const isBusy = actingTotalId === row.entryNo;
                const sc = STATUS_CONFIG[row.status] || STATUS_CONFIG[1];
                const canPay = row.canPay;
                const isApproved = row.status === 2;
                const isRejected = row.status === 3;
                const isPaid = row.status === 4;
                const iApprovedTotal = Boolean(row.iApproved);
                const isEditingThisTotal = editingTotalRow === row.entryNo;
                const canEditTotal = !isApproved && !isPaid && !isHrReadOnly;

                return (
                  <Paper
                    key={row.entryNo}
                    elevation={1}
                    sx={{
                      borderRadius: 2,
                      border: "1px solid",
                      // highlight totals !! 
                      borderColor: isLinkedTotal(row) ? "#f9a825" : selectedTotalIds.includes(row.entryNo) ? "#00796b" : "#e0f2f1",
                      borderWidth: isLinkedTotal(row) ? 2 : 1,
                      backgroundColor: isLinkedTotal(row) ? "#fff8e1" : undefined,
                      p: 1.5,
                    }}
                  >
                    <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 0.5 }}>
                        <Box>
                        <Stack direction="row" alignItems="center" spacing={0.3}>
                          <Typography variant="body2" fontWeight={700} sx={{ color: "#004d40" }}>
                            {row.fullName}
                          </Typography>
                          {conflictingTotalIds.has(row.entryNo) && <ConflictDot />}

               
                        </Stack>
                        <Typography variant="caption" sx={{ color: "text.secondary" }}>
                          {row.dateFrom} → {row.dateTo}
                        </Typography>
                      </Box>
                      <Chip label={sc.label} color={sc.color} size="small" variant="filled" sx={{ fontWeight: 700, fontSize: 11 }} />
                    </Stack>

                     {isEditingThisTotal ? (
                      <Stack direction="row" spacing={1} sx={{ my: 1 }}>
                        <TextField
                          size="small" label="Amount" type="number" fullWidth
                          value={editTotalValues.amount}
                          onChange={(e) => setEditTotalValues((prev) => ({ ...prev, amount: e.target.value }))}
                          inputProps={{ min: 0, step: 50 }}
                        />
                        <TextField
                          size="small" label="Km" type="number" fullWidth
                          value={editTotalValues.km}
                          onChange={(e) => setEditTotalValues((prev) => ({ ...prev, km: e.target.value }))}
                          inputProps={{ min: 0, step: 0.1 }}
                        />
                        <TextField
                          size="small" label="Parking" type="number" fullWidth
                          value={editTotalValues.parking}
                          onChange={(e) => setEditTotalValues((prev) => ({ ...prev, parking: e.target.value }))}
                          inputProps={{ min: 0, step: 50 }}
                        />
                      </Stack>
                    ) : (
                      <Stack direction="row" justifyContent="space-between" sx={{ my: 1 }}>
                        <Typography variant="body2">{Number(row.amount).toLocaleString()} L.L</Typography>
                        <Typography variant="body2">{row.km} Km</Typography>
                        <Typography variant="body2">{Number(row.parking).toLocaleString()} L.L park.</Typography>
                      </Stack>
                    )}

                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                      <Checkbox
                        size="small"
                        checked={selectedTotalIds.includes(row.entryNo)}
                        onChange={() => toggleSelectTotalRow(row.entryNo)}
                        disabled={!canApproveTotalRow(row)}
                      />
                      <Stack direction="row" spacing={0.5}>
                        <Tooltip title={isEditingThisTotal ? "Save changes" : canEditTotal ? "Edit amount / km / parking" : "Undo approval first to edit"}>
                          <span>
                            <IconButton
                              size="small"
                              onClick={() => (isEditingThisTotal ? handleSaveTotalEdit(row) : handleEditTotalClick(row))}
                              disabled={(!isEditingThisTotal && !canEditTotal) || savingTotalEdit}
                              sx={{ backgroundColor: isEditingThisTotal ? "#e8f5e9" : "#eceff1" }}
                            >
                              {isEditingThisTotal ? (
                                savingTotalEdit ? <CircularProgress size={16} /> : <SaveIcon fontSize="small" sx={{ color: "#2e7d32" }} />
                              ) : (
                                <EditIcon fontSize="small" />
                              )}
                            </IconButton>
                          </span>
                        </Tooltip>
                         {isPaid ? (
                          <IconButton color="success" size="small" sx={{ backgroundColor: "#e8f5e9" }} disabled>
                            <CheckCircleOutlineIcon fontSize="small" />
                          </IconButton>
                        ) : isApproved ? (
                          <IconButton color="warning" onClick={() => handleTotalAction(row, "undo")} size="small" sx={{ backgroundColor: "#fff8e1" }} disabled={isBusy}>
                            <UndoIcon fontSize="small" />
                          </IconButton>
                        ) : isRejected ? (
                          <IconButton color="warning" onClick={() => handleTotalAction(row, "reopen")} size="small" sx={{ backgroundColor: "#fff8e1" }} disabled={!canAct || isBusy}>
                            <UndoIcon fontSize="small" />
                          </IconButton>
                        ) : iApprovedTotal ? (
                          <IconButton color="warning" onClick={() => handleTotalAction(row, "undo")} size="small" sx={{ backgroundColor: "#fff8e1" }} disabled={isBusy}>
                            <UndoIcon fontSize="small" />
                          </IconButton>
                        ) : !canAct ? (
                          <IconButton color="success" size="small" sx={{ backgroundColor: "#e8f5e9" }} disabled>
                            <CheckCircleOutlineIcon fontSize="small" />
                          </IconButton>
                        ) : (
                          <IconButton color="success" onClick={() => handleTotalAction(row, "approve")} size="small" sx={{ backgroundColor: "#e8f5e9" }} disabled={isBusy}>
                            <CheckCircleOutlineIcon fontSize="small" />
                          </IconButton>
                        )}

                        <IconButton
                          color="error"
                          onClick={() => handleTotalAction(row, "reject")}
                          size="small"
                          sx={{ backgroundColor: "#ffebee" }}
                          disabled={isPaid || isRejected || (!canAct && !isApproved && !iApprovedTotal) || isBusy}
                        >
                          <CancelOutlinedIcon fontSize="small" />
                        </IconButton>

                        {isAcc && (
                          isPaid ? (
                            <IconButton size="small" sx={{ backgroundColor: "#fff8e1" }} disabled={isBusy} onClick={() => handleTotalAction(row, "unpay")}>
                              <UndoIcon fontSize="small" sx={{ color: "#f9a825" }} />
                            </IconButton>
                          ) : (
                            <IconButton size="small" sx={{ backgroundColor: "#fff8e1" }} disabled={!canPay || isBusy} onClick={() => handleTotalAction(row, "pay")}>
                              <PaidIcon fontSize="small" sx={{ color: "#f9a825" }} />
                            </IconButton>
                          )
                        )}
                      </Stack>
                    </Stack>
                  </Paper>
                );
              })}
            </Box>
          ) : (
          <Paper elevation={3} sx={{ borderRadius: 2, overflow: "auto", maxWidth: "100%" }}>
            <TableContainer sx={{ maxHeight: "50vh" }}>
              <Table size="small" stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox" sx={{ backgroundColor: "#004d40" }}>
                      <Checkbox
                        color="primary"
                        indeterminate={selectedTotalIds.length > 0 && selectedTotalIds.length < selectableTotalRowsForBulk.length}
                        checked={selectableTotalRowsForBulk.length > 0 && selectedTotalIds.length === selectableTotalRowsForBulk.length}
                        onChange={(e) => toggleSelectAllTotals(e.target.checked)}
                        disabled={selectableTotalRowsForBulk.length === 0}
                        sx={{ color: "white", "&.Mui-checked": { color: "#80cbc4" }, "&.MuiCheckbox-indeterminate": { color: "#80cbc4" } }}
                      />
                    </TableCell>
                    <TableCell sx={{ backgroundColor: "#004d40", color: "white", fontWeight: "bold", textAlign: "center" }}>Employee</TableCell>
                    <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", textAlign: "center" }}>Date Range</TableCell>
                    <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", textAlign: "center" }}>Amount (L.L)</TableCell>
                    <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", textAlign: "center" }}>Km</TableCell>
                    <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", textAlign: "center" }}>Parking (L.L)</TableCell>
                    <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", textAlign: "center" }}>Status</TableCell>
                    <TableCell sx={{ backgroundColor: "#00796b", color: "white", fontWeight: "bold", textAlign: "center" }}>Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  
                  {filteredTotalRows.map((row) => {
                    // const canAct = Boolean(row.canAct);
                    //const canAct = Boolean(row.canAct) && !isHrReadOnly;
                    const canAct = Boolean(row.canAct) && (!isHrReadOnly || row.asSupervisor);
                    const isBusy = actingTotalId === row.entryNo;
                    const sc = STATUS_CONFIG[row.status] || STATUS_CONFIG[1];
                    const canPay = row.canPay;
                                        const isApproved = row.status === 2;
                    const isRejected = row.status === 3;
                    const isPaid = row.status === 4;
                    const iApprovedTotal = Boolean(row.iApproved);
                    const isEditingThisTotal = editingTotalRow === row.entryNo;
                    const canEditTotal = !isApproved && !isPaid && !isHrReadOnly;

                    
                    return (
                      // filteredTotalRows.map
                        <TableRow
                            key={row.entryNo}
                            hover
                            sx={{
                              "& td": { fontSize: 13, py: 0.9, px: 1.5 },
                              backgroundColor: isLinkedTotal(row) ? "#fff8e1" : undefined,
                              "& td:first-of-type": { borderLeft: isLinkedTotal(row) ? "4px solid #f9a825" : undefined },
                            }}
                          >         
                        {/* Tells the supervisor exactly whose summary this is — same fullName field the visits table already uses */}
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={selectedTotalIds.includes(row.entryNo)}
                            onChange={() => toggleSelectTotalRow(row.entryNo)}
                            disabled={!canApproveTotalRow(row)}
                          />
                        </TableCell>
                          <TableCell sx={{ fontWeight: 600, color: "#004d40", textAlign: "center" }}>
                          <Stack direction="row" alignItems="center" justifyContent="center" spacing={0.3}>
                            <span>{row.fullName}</span>
                            {conflictingTotalIds.has(row.entryNo) && <ConflictDot />}
                          </Stack>
                        </TableCell>
                        <TableCell sx={{ textAlign: "center" }}>{row.dateFrom} → {row.dateTo}</TableCell>
                        <TableCell align="center">
                          {isEditingThisTotal ? (
                            <TextField
                              size="small" type="number" value={editTotalValues.amount}
                              onChange={(e) => setEditTotalValues((prev) => ({ ...prev, amount: e.target.value }))}
                              inputProps={{ min: 0, step: 50, style: { textAlign: "center" } }}
                              sx={{ width: 100 }}
                            />
                          ) : (
                            Number(row.amount).toLocaleString()
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {isEditingThisTotal ? (
                            <TextField
                              size="small" type="number" value={editTotalValues.km}
                              onChange={(e) => setEditTotalValues((prev) => ({ ...prev, km: e.target.value }))}
                              inputProps={{ min: 0, step: 0.1, style: { textAlign: "center" } }}
                              sx={{ width: 80 }}
                            />
                          ) : (
                            row.km
                          )}
                        </TableCell>
                        <TableCell align="center">
                          {isEditingThisTotal ? (
                            <TextField
                              size="small" type="number" value={editTotalValues.parking}
                              onChange={(e) => setEditTotalValues((prev) => ({ ...prev, parking: e.target.value }))}
                              inputProps={{ min: 0, step: 50, style: { textAlign: "center" } }}
                              sx={{ width: 90 }}
                            />
                          ) : (
                            Number(row.parking).toLocaleString()
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Chip label={sc.label} color={sc.color} size="small" variant="filled" sx={{ fontWeight: 700, fontSize: 11 }} />
                        </TableCell>

                                                  <TableCell align="center">
                          <Stack direction="row" justifyContent="center" spacing={0.5}>
                            {/* Edit / Save amount, km, parking — locked once approved or paid, opens back up after Undo */}
                            <Tooltip title={isEditingThisTotal ? "Save changes" : canEditTotal ? "Edit amount / km / parking" : "Undo approval first to edit"}>
                              <span>
                                <IconButton
                                  size="small"
                                  onClick={() => (isEditingThisTotal ? handleSaveTotalEdit(row) : handleEditTotalClick(row))}
                                  disabled={(!isEditingThisTotal && !canEditTotal) || savingTotalEdit}
                                  sx={{ backgroundColor: isEditingThisTotal ? "#e8f5e9" : "#eceff1" }}
                                >
                                  {isEditingThisTotal ? (
                                    savingTotalEdit ? <CircularProgress size={16} /> : <SaveIcon fontSize="small" sx={{ color: "#2e7d32" }} />
                                  ) : (
                                    <EditIcon fontSize="small" />
                                  )}
                                </IconButton>
                              </span>
                            </Tooltip>

                            {/* Approve / Undo / Reopen / Disabled — now shown to BOTH HR and regular supervisors */}
                            {isPaid ? (
                              <Tooltip title="Already paid — fully closed">
                                <span>
                                  <IconButton color="success" size="small" sx={{ backgroundColor: "#e8f5e9" }} disabled>
                                    <CheckCircleOutlineIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            ) : isApproved ? (
                              <Tooltip title="Undo approval (back to pending)">
                                <span>
                                  <IconButton
                                    color="warning"
                                    onClick={() => handleTotalAction(row, "undo")}
                                    size="small"
                                    sx={{ backgroundColor: "#fff8e1", "&:hover": { backgroundColor: "#ffecb3" } }}
                                    disabled={isBusy}
                                  >
                                    <UndoIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                                                        ) : isRejected ? (
                              <Tooltip title={canAct ? "Reopen as a new request" : "Only the supervisor who rejected this can reopen it"}>
                                <span>
                                  <IconButton
                                    color="warning"
                                    onClick={() => handleTotalAction(row, "reopen")}
                                    size="small"
                                    sx={{ backgroundColor: "#fff8e1", "&:hover": { backgroundColor: "#ffecb3" } }}
                                    disabled={!canAct || isBusy}
                                  >
                                    <UndoIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            ) : iApprovedTotal ? (
                              <Tooltip title="You already approved this — click to undo">
                                <span>
                                  <IconButton
                                    color="warning"
                                    onClick={() => handleTotalAction(row, "undo")}
                                    size="small"
                                    sx={{ backgroundColor: "#fff8e1", "&:hover": { backgroundColor: "#ffecb3" } }}
                                    disabled={isBusy}
                                  >
                                    <UndoIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            ) : !canAct ? (
                              <Tooltip title="Not your turn yet — a prior supervisor must act first">
                                <span>
                                  <IconButton color="success" size="small" sx={{ backgroundColor: "#e8f5e9" }} disabled>
                                    <CheckCircleOutlineIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            ) : (
                              <Tooltip title={isAcc ? "Approve (final sign-off — only once all supervisors have approved)" : "Approve"}>
                                <span>
                                  <IconButton
                                    color="success"
                                    onClick={() => handleTotalAction(row, "approve")}
                                    size="small"
                                    sx={{ backgroundColor: "#e8f5e9", "&:hover": { backgroundColor: "#c8e6c9" } }}
                                    disabled={isBusy}
                                  >
                                    <CheckCircleOutlineIcon fontSize="small" />
                                  </IconButton>
                                </span>
                              </Tooltip>
                            )}

                            {/* Reject — now shown to BOTH HR and regular supervisors */}
                            <Tooltip title={isPaid ? "Already paid" : isRejected ? "Already rejected — use Reopen instead" : (canAct || iApprovedTotal) ? "Reject" : "Not your turn yet"}>
                              <span>
                                <IconButton
                                  color="error"
                                  onClick={() => handleTotalAction(row, "reject")}
                                  size="small"
                                  sx={{ backgroundColor: "#ffebee", "&:hover": { backgroundColor: "#ffcdd2" } }}
                                  disabled={isPaid || isRejected || (!canAct && !isApproved && !iApprovedTotal) || isBusy}
                                >
                                  <CancelOutlinedIcon fontSize="small" />
                                </IconButton>
                              </span>
                            </Tooltip>

                            {/* Pay — still HR only, unchanged */}
                            {isAcc && (
                              isPaid ? (
                                <Tooltip title="Cancel payment (back to Approved)">
                                  <span>
                                    <IconButton
                                      size="small"
                                      sx={{ backgroundColor: "#fff8e1", "&:hover": { backgroundColor: "#ffecb3" } }}
                                      disabled={isBusy}
                                      onClick={() => handleTotalAction(row, "unpay")}
                                    >
                                      <UndoIcon fontSize="small" sx={{ color: "#f9a825" }} />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              ) : (
                                <Tooltip title={canPay ? "Mark as paid" : "Only available once fully approved"}>
                                  <span>
                                    <IconButton
                                      size="small"
                                      sx={{ backgroundColor: "#fff8e1", "&:hover": { backgroundColor: "#ffecb3" } }}
                                      disabled={!canPay || isBusy}
                                      onClick={() => handleTotalAction(row, "pay")}
                                    >
                                      <PaidIcon fontSize="small" sx={{ color: "#f9a825" }} />
                                    </IconButton>
                                  </span>
                                </Tooltip>
                              )
                            )}
                            
                          </Stack>
                        </TableCell>
                      </TableRow>
                    );
                  })}

                  {!filteredTotalRows.length && (
                    <TableRow>
                      <TableCell colSpan={7} sx={{ textAlign: "center", py: 3, opacity: 0.5 }}>
                        <Typography variant="body2" fontWeight={600} sx={{ color: "#004d40" }}>
                          No total transportation summaries waiting on your approval
                        </Typography>
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
          )}

        </Box>

        {/* feedback snackbar — identical pattern to ApproveLeavePage's */}
                {/* feedback snackbar — identical pattern to ApproveLeavePage's */}
        <Snackbar
          open={snack.open}
          autoHideDuration={3000}
          onClose={() => setSnack((s) => ({ ...s, open: false }))}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert onClose={() => setSnack((s) => ({ ...s, open: false }))} severity={snack.sev} variant="filled" sx={{ width: "100%" }}>
            {snack.msg}
          </Alert>
        </Snackbar>

        {/* Conflict explanation dialog — triggered by the red dot on any
            row, same wording as VisitHistoryPage's warning banner */}
        <Dialog
          open={conflictDialogOpen}
          onClose={() => setConflictDialogOpen(false)}
          PaperProps={{ sx: { borderRadius: 3 } }}
        >
          <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <WarningAmberIcon sx={{ color: "#f9a825" }} />
            Amount / Km / Parking Conflict
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" sx={{ color: "#7b4f00", fontWeight: 500 }}>
              This employee has non-zero amounts in both an individual visit record and in
              the Total Transportation summary for overlapping dates. Only one method
              should be used — either amounts entered per visit, or a total summary, not
              both.
            </Typography>
          </DialogContent>
          <DialogActions sx={{ p: 2.5 }}>
            <Button
              variant="contained"
              onClick={() => setConflictDialogOpen(false)}
              sx={{ bgcolor: "#00796b", "&:hover": { bgcolor: "#004d40" } }}
            >
              Got it
            </Button>
          </DialogActions>
        </Dialog>
      </Paper>
    </Box>
  );
    
}